import React,  { useState, useEffect } from 'react';
import styles from '../../../stylesheets/theme/bootstrap_scope.module.scss';
import ConditionalWrapper from "../../utils/ConditionalWrapper";
import {isMobile,  isTablet } from "react-device-detect";
import ReportThumbnail from "./ReportThumbnail";
import {autoDownload, parameterize} from "../../../javascripts/utils";

// import thumb from '../../../images/reports/thumbnail_bg.png';
// import triple_thumb from '../../../images/reports/triple_thumbnail_bg.webp';

/** This components accepts an array of reports, containing title, formatted date and url to the pdf. **/

function LeadResponseNotice({reports, theme_enabled, user_confirmed, research_dashboard}) {

    const backgroundStyle = {
        background: "url('https://images.peerspot.com/image/upload/v1742454294/site-images/home-page-hero-background-left.svg') no-repeat center top"
    }

    const researchDashboardStyle = {
        maxHeight: (isMobile || isTablet) ? 'auto' : '230px', overflow: 'hidden'
    }

    const titleSizingClass = () => {
        if(reports.some((report) => report.title.length >= 80)) return styles['report-title-sm'];
        if(reports.some((report) => report.title.length > 50 && report.title.length < 80)) return styles['report-title-md'];
    }

    const BANNER_WIDTH = theme_enabled ? {} : { maxWidth: 'min(100%, 980px)'}
    const REPORT_COUNT = reports.length;
    const MAX_REPORT_THUMBS = 3;
    const TITLE_SIZE_CLASS = titleSizingClass();

    useEffect(() => {
        if(user_confirmed && research_dashboard) {
            reports.forEach( (report) => { autoDownload(report.url, `${parameterize(report.title)}.pdf`) });
        }
    }, []);

    // These are now preloaded on the page...
    // // preload thumb image
    // const thumbImages = [thumb, triple_thumb];
    // for (const image of thumbImages) {
    //     const imageElement = new Image();
    //     imageElement.src = image;
    // }

    const renderResponse = () => {
        if(user_confirmed) {
            return (
                <>
                    {renderHeader(`Thank you for downloading the report${REPORT_COUNT > 1 ? ' bundle' : ''}!`)}
                    {renderReportLinks()}
                </>
            )
        } else {
            return (
                <>
                    {renderHeader('Thank you!')}
                    {renderSubHeader(`A link to your ${ REPORT_COUNT > 1 ? 'free research bundle' : 'report'} will be sent to your email shortly.`)}
                </>
            )
        }
    }

    const renderHeader = (txt) => {
        return (
            <h3 className={`${styles['fs-2']}`}>{txt}</h3>
        )
    }

    const renderSubHeader = (txt) => {
        return (
            <div className={`${styles['content-styling']} ${styles['gray-800']} ${styles['font-family-secondary']}`}>{txt}</div>
        )
    }

    const renderReportLinks = () => {
        let linkClasses = `${styles['text-blue-link']} ${styles['hover-blue-hover']} ${styles['font-family-secondary']} ${styles['text-decoration-underline']}`;
        return (
            <ConditionalWrapper condition={REPORT_COUNT > 1} wrapper={children => <ul style={{ paddingLeft: '1rem' }}>{children}</ul>}>
                { reports.map( (report, i) => {
                    return (
                        <ConditionalWrapper condition={REPORT_COUNT > 1} key={`report_${i}`} wrapper={children => <li className={`${styles['text-top']}`}>{children}</li>}>
                            <div className={`${styles['py-1']}`}>
                                <a href={report.url} className={linkClasses} target="_blank">{ REPORT_COUNT > 1 ? report.title : 'Download PDF' }</a>
                            </div>
                        </ConditionalWrapper>
                    ) }
                ) }
            </ConditionalWrapper>
        )
    }

    return (
        <div className={'bootstrap'}>
            <div className={`${styles['container-fluid']} ${styles['border-bottom']}`} style={ research_dashboard ? researchDashboardStyle : backgroundStyle}>
                <div className={`${styles['container-lg']} ${!research_dashboard && styles['py-3']} ${!research_dashboard && styles['py-md-5']}`} style={BANNER_WIDTH}>
                    <div className={`${styles['row']} ${ research_dashboard ? styles['align-items-start'] : styles['align-items-center']}`}>
                        <div className={`${styles['col-md-6']} ${styles['col-lg-5']} ${research_dashboard && styles['col-xl-4']} ${styles['px-0']}`}>
                            <ReportThumbnail reports={reports[0] ? [reports[0]] : []} tripleThumb={true} />
                        </div>
                        <div className={`${styles['pt-3']} ${styles['pt-md-0']} ${styles['col-md-6']} ${styles['col-lg-7']} ${research_dashboard && styles['col-xl-8']} ${research_dashboard && 'mt-md-5'}`}>
                            {renderResponse()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

LeadResponseNotice.displayName = 'LeadResponseNotice';

export default LeadResponseNotice;